import React from 'react';
import TpVastConfig from './Components/TpVastConfig';
import TpVastReportingConfig from './Components/TpVastReporting';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';
import { TPVAST_CONSTANTS } from '../../../../../core/constants';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';

const {
	TP_VAST_CONFIG_TABS: { TP_VAST_CONFIG, TP_VAST_REPORTING }
} = TPVAST_CONSTANTS;

const tabListAndPanels = [
	{
		tab: <Tab label="Tp Vast Config" value={TP_VAST_CONFIG} key={TP_VAST_CONFIG} />,
		tabPanel: (
			<TabPanel
				value={TP_VAST_CONFIG}
				key={TP_VAST_CONFIG}
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<TpVastConfig />
			</TabPanel>
		)
	},
	{
		tab: <Tab label="Tp Vast Reporting" value={TP_VAST_REPORTING} key={TP_VAST_REPORTING} />,
		tabPanel: (
			<TabPanel
				value={TP_VAST_REPORTING}
				key={TP_VAST_REPORTING}
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<TpVastReportingConfig />
			</TabPanel>
		)
	}
];

const TpVastConfigTab = () => {
	return (
		<GeneralTab
			tabListAndPanels={tabListAndPanels}
			tabListStyles={{
				width: 'full-width',
				margin: '5rem 5rem'
			}}
		/>
	);
};

export default TpVastConfigTab;
